import '../css/app.css';
import '../sass/app.scss';
import 'vue3-toastify/dist/index.css';
import './helpers.js';
import {createApp, h} from 'vue';
import {createInertiaApp} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from '../../vendor/tightenco/ziggy';
import {initFlowbite} from "flowbite";
import {createI18n} from 'vue-i18n';
import Vue3Toasity from 'vue3-toastify';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import {createPinia} from "pinia";
import {initEcho} from '@/plugins/echo.js';

const appName = import.meta.env.VITE_APP_NAME || 'Content-tool';
import de from "./locales/de.json";
import en from "./locales/en.json";

const i18n = createI18n({
    locale: "de",
    fallbackLocale: "de",
    messages: {de, en},
    legacy: false,
    globalInjection: true
});

const pinia = createPinia();

initEcho();

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({el, App, props, plugin}) {
        return createApp({render: () => h(App, props)})
            .use(plugin)
            .use(ZiggyVue)
            .use(i18n)
            .use(pinia)
            .use(PrimeVue, {
                theme: {
                    preset: Aura,
                    options: {
                        darkModeSelector: false,
                    }
                }
            })
            .use(Vue3Toasity, {
                autoClose: 3000,
            })
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
}).then(() => {
    initFlowbite();
});
